export const FLAG_GETTING_PRIVATE_SERVICES = 'FLAG_GETTING_PRIVATE_SERVICES';
export const GET_PRIVATE_SERVICES = 'GET_PRIVATE_SERVICES';
export const CLEAR_PRIVATE_SERVICES = 'CLEAR_PRIVATE_SERVICES';
export const FLAG_PRIVATE_SERVICE_ACTIVITY = 'FLAG_PRIVATE_SERVICE_ACTIVITY';
export const GET_PRIVATE_SERVICE = 'GET_PRIVATE_SERVICE';
export const CLEAR_PRIVATE_SERVICE = 'CLEAR_PRIVATE_SERVICE';
